var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-scorpion"},[_c('span',{staticClass:"authorName font-weight-bold text-break"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" | "),(_vm.publishDate)?_c('span',{staticClass:"postDate"},[_vm._v(_vm._s(_vm.publishDate))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }